let audioCtx = null;

const getAudioCtx = () => {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
};

const tryResume = () => {
  const ctx = getAudioCtx();
  if (ctx.state === 'suspended') {
    ctx.resume();
  }
};

if (typeof window !== 'undefined') {
  window.addEventListener('click', tryResume, { once: true });
  window.addEventListener('touchstart', tryResume, { once: true });
  window.addEventListener('keydown', tryResume, { once: true });
}

const playTone = (frequency, duration, type = 'sine', volume = 0.3) => {
  try {
    const ctx = getAudioCtx();
    if (ctx.state === 'suspended') {
      ctx.resume().then(() => {
        scheduleTone(ctx, frequency, duration, type, volume);
      });
      return;
    }
    scheduleTone(ctx, frequency, duration, type, volume);
  } catch (e) {
    // Audio not supported
  }
};

const scheduleTone = (ctx, frequency, duration, type, volume) => {
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = frequency;
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (e) {
    // Audio not supported
  }
};

export const playNotificationSound = () => {
  playTone(1200, 0.12, 'sine', 0.25);
};

export const playToastSound = () => {
  playTone(880, 0.08, 'sine', 0.2);
  setTimeout(() => playTone(1320, 0.1, 'sine', 0.2), 100);
};
